import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <path
    id="Combined Shape"
    fillRule="evenodd"
    clipRule="evenodd"
    d="M21.874 11.5043C21.234 10.3943 17.714 4.82427 11.734 5.00427C6.20397 5.14427 3.00397 10.0043 2.13397 11.5043C1.95534 11.8137 1.95534 12.1949 2.13397 12.5043C2.76397 13.5943 6.13397 19.0043 12.024 19.0043H12.274C17.804 18.8643 21.014 14.0043 21.874 12.5043C22.0526 12.1949 22.0526 11.8137 21.874 11.5043ZM12.224 17.0043C7.91397 17.1043 5.10397 13.4143 4.22397 12.0043C5.22397 10.3943 7.83397 7.10427 11.834 7.00427C16.124 6.89427 18.944 10.5943 19.834 12.0043C18.804 13.6143 16.224 16.9043 12.224 17.0043ZM12.004 8.50427C10.071 8.50427 8.50397 10.0713 8.50397 12.0043C8.50397 13.9373 10.071 15.5043 12.004 15.5043C13.937 15.5043 15.504 13.9373 15.504 12.0043C15.504 10.0713 13.937 8.50427 12.004 8.50427ZM12.004 13.5043C11.1755 13.5043 10.504 12.8327 10.504 12.0043C10.504 11.1758 11.1755 10.5043 12.004 10.5043C12.8324 10.5043 13.504 11.1758 13.504 12.0043C13.504 12.8327 12.8324 13.5043 12.004 13.5043Z"
    fill={fill}
  />
);

export default Icon;
